import BaseSelectionType from "./BaseSelectionType";
import SelectedData from "./model/SelectedData";

export default class RunnerSelectionType extends BaseSelectionType{
    accept(visitor, selectedRegion)
    {
        return visitor.visitRunnerSelection(selectedRegion);
    }

    getSelectedData(lockTable, selectedRegion)
    {
        return new SelectedData(lockTable.getRunnerController().getSelectedDateRange(), null);
    }

    isLocking(runnerController)
    {
        var lastLockedDate = runnerController.getLastLockedDate();
        if (lastLockedDate == null)
            return true;

        var newLastLockedDate = runnerController.getNewLastLockDate();
        return lastLockedDate.getTime() < newLastLockedDate.getTime();
    }

    canBeLocked(lockTable, selectedRegion)
    {
        return this.isLocking(lockTable.getRunnerController());
    }

    canBeUnlocked(lockTable, selectedRegion)
    {
        return !this.isLocking(lockTable.getRunnerController());
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/RunnerSelectionType.js